export interface Category {
  id: string;
  name: string;
  short: string;
  description: string;
  icon: string;
  accent: string;
}

export const categories: Category[] = [
  {
    id: "hot",
    name: "全网热议",
    short: "热议",
    description: "各大平台讨论度飙升的话题整理，看大家今天都在聊什么。",
    icon: "ri-fire-line",
    accent: "primary",
  },
  {
    id: "variety",
    name: "综艺现场",
    short: "综艺",
    description: "节目录制花絮、剪辑争议与嘉宾互动，台前幕后的完整脉络。",
    icon: "ri-mic-line",
    accent: "accent",
  },
  {
    id: "drama",
    name: "影视动态",
    short: "影视",
    description: "新剧上线、收视走势、结局讨论，一次看懂影视圈风向。",
    icon: "ri-film-line",
    accent: "secondary",
  },
  {
    id: "idol",
    name: "舞台与现场",
    short: "舞台",
    description: "音乐节、演唱会、舞台直拍的现场记录与观众反馈汇总。",
    icon: "ri-music-2-line",
    accent: "primary",
  },
  {
    id: "industry",
    name: "行业观察",
    short: "行业",
    description: "从选角、制作到宣发，观察内容行业正在发生的变化。",
    icon: "ri-line-chart-line",
    accent: "accent",
  },
  {
    id: "community",
    name: "社区趣闻",
    short: "社区",
    description: "热梗考古、网友盘点、名场面集锦，轻松一刻的社区精选。",
    icon: "ri-chat-smile-2-line",
    accent: "secondary",
  },
];